export const qk = {
  objectTypes: () => ["objectTypes"] as const,
  objectType: (id: string) => ["objectTypes", id] as const,
  relationshipTypes: () => ["relationshipTypes"] as const,
  instances: (typeId: string, params: Record<string, unknown>) =>
    ["instances", typeId, params] as const,
  instance: (id: string) => ["instances", id] as const,
  relationships: (instanceId: string) =>
    ["instances", instanceId, "relationships"] as const,
  graph: (instanceId: string, params: Record<string, unknown>) =>
    ["graph", instanceId, params] as const,
  search: (q: string, types: string[]) => ["search", q, types] as const,
  tags: (q?: string) => ["tags", q ?? ""] as const,
  map: (params: Record<string, unknown>) => ["map", params] as const,
  attachments: (instanceId: string) =>
    ["instances", instanceId, "attachments"] as const,
  cases: (params?: Record<string, unknown>) => ["cases", params ?? {}] as const,
  case: (id: string) => ["cases", id] as const,
  timeline: (params: Record<string, unknown>) => ["timeline", params] as const,
  enrichmentProviders: () => ["enrichmentProviders"] as const,
  enrichmentAvailable: (instanceId: string) =>
    ["enrichment", instanceId, "available"] as const,
  enrichmentHistory: (instanceId: string) =>
    ["enrichment", instanceId, "history"] as const,
};
